<script>
export default {
	name: "CbsContextMenu",
	inheritAttrs: false,
	props: {
		type: {
			type: String,
			default: "horizontal",
			validator: prop => ["vertical", "horizontal"].includes(prop)
		},
		menuListDataBinding: Object
	},
	methods: {
		hanldeClickMenuItem(event) {
			event.stopPropagation();
			event.preventDefault();
			if (this.$refs.cbsContextMenuRef && event.target && event.target.className && !event.target.className.split(" ").includes("item__divider")) {
				this.$refs.cbsContextMenuRef.$el.click();
			}
		}
	},
	render() {
		const menuClass = `cbs-context-menu-list ${(this.menuListDataBinding && this.menuListDataBinding.class) || ""}`;
		const componentClasses = `cbs-context-menu cursor-pointer ${this.type === "vertical" ? "cbs-context-menu--vertical" : this.type === "horizontal" ? "cbs-context-menu--horizontal" : ""}`;

		return (
			<vs-dropdown ref="cbsContextMenuRef" {...this.$attrs} {...this.$listeners} vs-trigger-click vs-custom-content class={componentClasses}>
				<i class="nucleo nucleo-dots font-bold cbs-context-menu__btn-trigger" />
				<vs-dropdown-menu {...this.menuListDataBinding} class={menuClass}>
					{this.$slots &&
						this.$slots.default &&
						this.$slots.default.map(
							vnode =>
								vnode.tag && (
									<div class="item cbs-context-menu-list__item" onClick={this.hanldeClickMenuItem}>
										{{
											...vnode,
											data: {
												...vnode.data,
												class: vnode.data && vnode.data.staticClass + " px-3 py-2 hover:bg-gray-7 cursor-pointer"
											}
										}}
										{vnode.data && vnode.data.attrs && (vnode.data.attrs.divider || vnode.data.attrs.divider === "") && (
											<div class="item__divider my-2 border-solid border-0 border-b border-gray-6"></div>
										)}
									</div>
								)
						)}
				</vs-dropdown-menu>
			</vs-dropdown>
		);
	}
};
</script>

<style lang="scss" scoped>
.cbs-context-menu {
	width: 30px;
	margin-right: -5px;

	.cbs-context-menu__btn-trigger {
		margin-right: 5px;
		font-size: 20px;
		color: var(--color-solid-primary);
	}

	&.cbs-context-menu--vertical {
		margin-right: -10px;
		transform: rotate(90deg);

		.cbs-context-menu__btn-trigger {
			margin-right: 0;
		}
	}
}
</style>
